import React from 'react';
import Card from '../../../components/Card';
import SemesterLayout from '../../../components/SemesterLayout';

const Sem3 = ({ branch = "AIML" }) => {
  const notes = [
    { title: 'Foundation Of Data Science', link: `/notes/${branch.toLowerCase()}/Fods` },
    { title: 'Digital Logic Design', link: `/notes/${branch.toLowerCase()}/DLCD_AI` },
    { title: 'Crystal Reasoning and System Thinking', link: `/notes/${branch.toLowerCase()}/CR` },
    { title: 'Data Structures', link: `/notes/${branch.toLowerCase()}/Data Structure` },
    { title: 'Principles of Artificial Intelligence', link: `/notes/${branch.toLowerCase()}/AI` },
    { title: 'Probability, Statistics and Linear Algebra', link: `/notes/${branch.toLowerCase()}/Psla` },
    { title: 'Universal Human Values II', link: `/notes/${branch.toLowerCase()}/UHV-II_AI` }
  ];

  return (
    <SemesterLayout
      branch={branch}
      semester="3rd Semester"
    >
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {notes.map((note, index) => (
          <Card key={index} title={note.title} link={note.link} />
        ))}
      </div>
    </SemesterLayout>
  );
};

export default Sem3;
